import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setCartItem } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { openCart } from "../../redux/slices/uiSlice";
import ProductCard from "./ProductCard";
import { useGetWishlistQuery } from "../../redux/api/wishlistApi";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const WishlistPage = () => {
  const { user } = useSelector((state) => state.auth);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const dispatch = useDispatch();

  const { data, isLoading, isError } = useGetWishlistQuery(undefined, {
    skip: !user,
  });

  const addItemToCart = (product) => {
    const existingCartItem = cartItems.find(
      (item) => item.product === product._id
    );

    if (existingCartItem && existingCartItem.quantity >= product.stock) {
      toast.error("Maximum items already added");
      return;
    }

    const newQuantity = existingCartItem ? existingCartItem.quantity + 1 : 1;

    dispatch(
      setCartItem({
        product: product?._id,
        name: product?.name,
        price: product?.price,
        image: product?.images[0]?.url,
        stock: product?.stock,
        quantity: newQuantity,
      })
    );

    dispatch(openCart());
    toast.success(existingCartItem ? "Quantity updated" : "Added to bag");
  };

  // Guards first, data extraction after
  if (!user) {
    return (
      <p className="text-center px-10 py-60 font-sourcesans text-xl">
        Please{" "}
        <Link className="text-[#3fbcb1] font-medium" to="/login">
          login
        </Link>{" "}
        to view your favorites{" "}
        <span className="text-[#BC3F4A]">&#9829;</span>
      </p>
    );
  }

  if (isLoading) {
    return (
      <p className="text-center px-10 py-60 font-sourcesans text-xl">
        Loading your wishlist...
      </p>
    );
  }

  if (isError) {
    return (
      <p className="text-center px-10 py-60 font-sourcesans text-xl">
        Failed to load wishlist.
      </p>
    );
  }

  const wishlist = (data?.wishlist ?? []).filter((item) => item.product);

  return (
    <>
      <Helmet>
        <title>My Wishlist — Sanguine Accent</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="wishlist-page mt-24 md:mt-40 container mx-auto p-4">
        <h2 className="text-xl text-stone-700 font-sourcesans font-medium mb-4">
          {user.name}&apos;s List
        </h2>

        {wishlist.length === 0 ? (
          <p className="font-sourcesans text-stone-500">Your list is empty.</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {wishlist.map((item) => (
              <ProductCard
                key={item._id}
                product={item.product}
                addItemToCart={addItemToCart}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default WishlistPage;